"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_tippy_1 = require("react-tippy");
var index_1 = __importStar(require("../Icon/index"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var InputContainer = /** @class */ (function (_super) {
    __extends(InputContainer, _super);
    function InputContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceUpdateOnChange = function () {
            _this.forceUpdate();
        };
        return _this;
    }
    InputContainer.prototype.componentDidMount = function () {
        LocaleProvider_1.default.on(this.forceUpdateOnChange);
    };
    InputContainer.prototype.componentWillUnmount = function () {
        LocaleProvider_1.default.off(this.forceUpdateOnChange);
    };
    InputContainer.prototype.render = function () {
        var _a = this.props, error = _a.error, children = _a.children, className = _a.className, label = _a.label, hint = _a.hint, format = _a.format, required = _a.required, labelCol = _a.labelCol, edited = _a.edited, disabled = _a.disabled, _b = _a.formGroup, formGroup = _b === void 0 ? true : _b, rest = __rest(_a, ["error", "children", "className", "label", "hint", "format", "required", "labelCol", "edited", "disabled", "formGroup"]);
        var cn = classnames_1.default("emankit__input_container", formGroup && "form-group", className, {
            error: !!error,
            edited: edited,
            disabled: !!disabled,
        });
        var errorMessage = null;
        if (error) {
            errorMessage = react_1.default.createElement("div", { className: "error_message", dangerouslySetInnerHTML: { __html: error } });
        }
        var hintMessage = null;
        if (hint) {
            hintMessage = (react_1.default.createElement(react_tippy_1.Tooltip, { title: hint, arrow: true, animation: "shift", style: { display: "inline-block" }, className: "emankit__label_tooltip" },
                react_1.default.createElement(index_1.default, { icon: index_1.IconType.HelpLight, width: 20, height: 20, className: "emankit__icon_circle_fakefill" })));
        }
        var requiredMark = null;
        if (required) {
            requiredMark = react_1.default.createElement("span", { className: "required" }, LocaleProvider_1.default.locs.input_container.required_text);
        }
        // Determine sizes
        var labelSm = labelCol || 2;
        var inputSm = labelCol !== 12 ? 12 - labelSm : 12;
        var boundChildren = react_1.default.Children.map(children, function (child) {
            if ((child.type && child.type === "input") || child.type === "select" || child.type === "checkbox") {
                return react_1.default.cloneElement(child, { disabled: disabled });
            }
            else {
                /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
                return child;
            }
        });
        if (!label) {
            // Does not matter, because we have no label!
            return (react_1.default.createElement("div", __assign({ className: cn }, rest),
                react_1.default.createElement("div", null, boundChildren),
                hintMessage,
                errorMessage));
        }
        else if (!format || format === "row") {
            // Rows
            return (react_1.default.createElement("div", __assign({ className: cn + " row" }, rest),
                react_1.default.createElement("label", { className: "col-sm-" + labelSm + " col-form-label" },
                    label,
                    requiredMark,
                    hintMessage),
                react_1.default.createElement("div", { className: "col-sm-" + inputSm + " col-form-input" },
                    react_1.default.createElement("div", null, boundChildren),
                    errorMessage)));
        }
        else {
            // Columns
            return (react_1.default.createElement("div", __assign({ className: cn + " row" }, rest),
                react_1.default.createElement("label", { className: "col-form-label col-sm-12" },
                    label,
                    requiredMark,
                    hintMessage),
                react_1.default.createElement("div", { className: "col-sm-12 col-form-input" }, boundChildren),
                react_1.default.createElement("div", { className: "col-sm-12" }, errorMessage)));
        }
    };
    return InputContainer;
}(react_1.default.Component));
exports.default = InputContainer;
//# sourceMappingURL=index.js.map